export enum FlagsSortField {
  User = 'user',
  FlagDetails = 'flagDetails',
  Author = 'author',
  CreatedAt = 'createdAt',
  ResolvedAt = 'resolvedAt',
  Status = 'status',
}
